import { RequestCriteriaType } from "@infrastructure/Services/PostService.types";
import { UsersGroupParticipant } from "@infrastructure/Services/GroupService.types";
import { GroupParticipationSourceType } from "../../Domain/GroupParticipationSource";
import { GroupTypeEnum } from "../Pages/GroupDetailsPage/Group.types";

export function isUserCreator(userRole: string) {
    return userRole === "creator";
}

export type User = {
    activeState: string | null;
    allowToContact: boolean;
    avatar: string | null;
    gender: string;
    isActive: boolean;
    role: string;
    screenName: string;
    uuid: string;
};

export type UserType = User & {
    trust: UserTrust;
    // TODO: refactor avatar property: unify and reduce types
    avatar?: string | undefined;
    gender?: string | undefined;
    statistics?: UserStatistics;
    title?: string | undefined;
    totalScore?: number | undefined;
    allowToContact: boolean;
};

export type LatestReactedUserType = UserType & {
    reactionType: string;
};

export type UserTrust = {
    isTrusted: boolean;
    trustNote?: string;
};

export type UserStatistics = {
    commentsCount: number;
    contributionsCount: number;
    groupsJoinedCount: number;
    likesGivenCount: number;
    likesReceivedCount: number;
    postsCount: number;
    atLocation?: boolean;
    engagementScore?: string;
    experienceScore?: string;
};

export type GroupType = {
    activeBooking: boolean;
    activeBookingLabel: string | null;
    atLocation: boolean;
    groupTypeWithParentName: string;
    id: number;
    isMember: boolean;
    name: string;
    subline: string;
    type: GroupTypeEnum;
    distanceInKilometers?: number;
    groupCategory?: string;
    groupHref?: string;
    image?: string;
    isPromoted?: boolean;
    onBookmarkChange?: (value: boolean) => void;
    onClick?: () => void;
    onClose?: () => void;
    onJoinedChanged?: (joined: boolean) => void;
    onParticipantsClick?: () => void;
    parentName?: string;
    participantsAtLocation?: UsersGroupParticipant[];
    position?: google.maps.LatLngLiteral;
    showGroupCardButton?: boolean;
    source?: GroupParticipationSourceType;
    topParticipants?: UsersGroupParticipant[];
};

export type FetcherPaginated<T> = (
    fetchParams: FetchParams,
    prepareParams?: object,
    abortController?: AbortController,
) => Promise<T[]>;

export type FetchStrategyType = "before" | "after" | "offset";

export type FetchStrategy = {
    cursorKey: string;
    strategy: FetchStrategyType;
    uniqueField: string;
};

export type FetchParams = {
    [key: string]: string | number | any;
    objectId?: number;
    sortCriteria?: RequestCriteriaType;
};
